export enum CatalogueType {
  Winter,
  Summer,
  None,
}
